import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppConstants } from '../app.constants';
import { Globals } from '../models/globals.model';
import { Refinery } from '../models/refinery.model';
import { Tenant } from '../models/tenant.model';
import { GraphService } from './graph.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService  {
  private readonly tenantList$ = new Subject<Refinery[]>();
  private currentTenant: Tenant;
  apiUri: string;
  graphUri: string;
  constructor(private readonly httpService: HttpService, private readonly globals: Globals,
    private readonly graphService: GraphService) {
    this.apiUri = this.globals.config.platformAdminApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  

  /**
   * calls api for getting list of tenants and exports data to other
   * components using subject
   */
  getTenantListFromServer(componentId: number) {
    this.httpService.get(this.apiUri + 'api/Tenant/GetRefineries?componentId=' + componentId, null).subscribe((data: Refinery[]) => {
      if (data && data.length > 0) {
        data.forEach(element => {
          if (element.tenantList !== null) {
            const filteredTenants: Tenant[] = this.filterTenants(element.tenantList);
            // case for a user who dont have access on any of the tenant of donges
            // so that he/she will be able to access data of Test Bed tenant
            if (filteredTenants.length === 0 && element.refineryName === 'Donges') {
              filteredTenants.push(element.tenantList.find(tenant1 => tenant1.tenantSecurityGrp === AppConstants.platformAdminT1GroupId));
            } else if (filteredTenants.length === 0 && element.refineryName !== 'Donges') {
              data.splice(data.indexOf(element), 1);
            }
            element.tenantList = filteredTenants;
          } else {
            data.splice(data.indexOf(element), 1);
          }
        });
      }
      this.tenantList$.next(data);
    }, (err) => {
      console.log(err);
    });
  }

  /**
   * filters list of tenants available with security grps of user
   * @param data list of all tenants available
   */
  filterTenants(data: Tenant[]): Tenant[] {
    const groups: string[] = this.graphService.user.groupIDs;
    const finalTenantList: Tenant[] = [];
    for (let i = 0; i < groups.length; i++) {
      const tenant: Tenant = data.find(tenant1 => tenant1.tenantSecurityGrp === groups[i]);
      if (tenant) {
        finalTenantList.push(tenant);
      }
    }
    finalTenantList.sort((a:any, b:any) => (a.tenantName > b.tenantName ? 1 : -1));
    this.setCurrentTenant(finalTenantList[0]);
    return finalTenantList;
  }

  /**
   * @returns tenantlist as an observable
   */
  getTenants() {
    return this.tenantList$.asObservable();
  }

  /**
   * sets current tenant
   * @param tenant current tenant to be set
   */
  setCurrentTenant(tenant) {
    this.currentTenant = tenant;
  }

  /**
   * @returns current tenant
   */
  getCurrentTenant() {
    return this.currentTenant;
  }
}
